export const deliveryConstants = {
  CLEAN_ALL: 'CLEAN_ALL',
  SET_DNI_PHOTO: 'SET_DNI_PHOTO',
  SET_CLIENT_PHOTO: 'SET_CLIENT_PHOTO',
  SET_SIGN: 'SET_SIGN',
  SET_OC: 'SET_OC'
}
